import withGS from '../core/withGShoc';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ENTITLEMENTS } from '../application-core/constants';
import { STATUS_ACCEPTED } from '../core/utils/constants';
import DataOptions from '../core/DataOptions';
import HistoryViewer from '../core/HistoryViewer';
import { ProjectConsumer } from '../core/providers/ProjectProvider';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../core/style/gstheme';
import TripleViewer from '../core/TripleViewer';
import ResourceSummaryDetail from '../ontology/ResourceSummaryDetail';
import ResourceDetail from './ResourceDetail';
import ResourceVisualisationDialog from '../application-core/visualisation/ResourceVisualisationDialog';
import { RESOURCE_CONFIGURATION } from './constants';

const APPROVED = STATUS_ACCEPTED;

const CLASSES = {
  "Resource": {
  }
};

class ResourceData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0,
      pendingSuggestionCount: 0,
      scroll: false,
      resourceIRI: null
    };
    this.resourceDataRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    // For a change of resource scroll back to top
    if (props.resourceIRI !== state.resourceIRI) {
      return {
        resourceIRI: props.resourceIRI,
        scroll: true
      };
    }
    return null;
  }

  componentDidMount() {
    if (this.props.data.pendingDeletion) return;
    this.resourceDataRef.current.scrollIntoView({
      block: 'center',
      inline: 'center',
    });
    this.setState({ scroll: false });
  }

  componentDidUpdate() {
    if (this.state.scroll && this.resourceDataRef && this.resourceDataRef.current && !this.props.data.pendingDeletion) {
      this.resourceDataRef.current.scrollIntoView({
        block: 'center',
        inline: 'center',
      });
      this.setState({ scroll: false });
    }
  }

  changeView = (index) => this.setState({ view: index });

  render() {

    const { graph, datasetIRI, isReadOnly, resourceIRI, onDeleteResource, useWorkflow, projectUsers, ontologyProjects, annotate,
      propertyTemplates, linkedData, project, data, viewLang, useSlashIRI, useUuidIRI, move, entitlements, associatedProject } = this.props;
    const { view } = this.state;
    const showOntologyProjects = entitlements.includes(ENTITLEMENTS.VIEW_ONTOLOGY_PROJECT) || entitlements.includes(ENTITLEMENTS.EDIT_ONTOLOGY_PROJECT);
    const isApproved = (useWorkflow && "status" in data && data.status[0]) === APPROVED ? true : false;

    return (
      <ProjectConsumer>
        {({ defaultLang }) => (
          <div ref={this.resourceDataRef}>
            <DataOptions
              handleNotAvailable={true}
              useWorkflow={useWorkflow}
              id={resourceIRI}
              graph={graph}
              changeView={this.changeView}
              view={this.state.view}
              historyOption={true}
            />
            <div style={{ float: 'right', width: 'calc(100% - 60px)', marginBottom: '20px', paddingLeft: '10px' }}>
              <ResourceSummaryDetail
                handleNotAvailable={true}
                baseIRI={datasetIRI}
                project={project}
                useWorkflow={useWorkflow}
                allowIRIchange={false}
                isReadOnly={isReadOnly || isApproved || data.pendingDeletion ? true : false}
                graph={graph}
                additionalViews={
                  <ResourceVisualisationDialog
                    defaultLang={defaultLang}
                    ontologyProjects={ontologyProjects}
                    associatedProject={associatedProject}
                    viewLang={viewLang}
                    objectPropertyConfiguration={RESOURCE_CONFIGURATION}
                    displayClasses={CLASSES}
                    sourceNode={resourceIRI}
                    graph={graph} />
                }
                defaultLang={defaultLang}
                id={resourceIRI}
                name="label"
                viewLang={viewLang}
                canDeprecate={true}
                onDeleteResource={onDeleteResource}
                permission={ENTITLEMENTS.EDIT_DATASET} />
              {view === 0 &&
                <ResourceDetail
                  move={move}
                  useWorkflow={useWorkflow}
                  handleNotAvailable={true}
                  defaultLang={defaultLang}
                  viewLang={viewLang}
                  entitlements={entitlements}
                  project={project}
                  projectUsers={projectUsers}
                  annotate={annotate}
                  showOntologyProjects={showOntologyProjects}
                  onDeleteResource={onDeleteResource}
                  datasetIRI={datasetIRI}
                  useSlashIRI={useSlashIRI}
                  useUuidIRI={useUuidIRI}
                  linkedData={linkedData}
                  associatedProject={associatedProject}
                  propertyTemplates={propertyTemplates}
                  graph={graph}
                  id={resourceIRI} />}
              {view === 1 &&
                <TripleViewer
                  handleNotAvailable={true}
                  requiredEntitlement={ENTITLEMENTS.EDIT_DATASET}
                  useWorkflow={useWorkflow}
                  id={resourceIRI}
                  graph={graph} />}
              {view === 4 &&
                <HistoryViewer
                  handleNotAvailable={true}
                  id={resourceIRI}
                  graph={graph} />}
            </div>
          </div>
        )}
      </ProjectConsumer>
    );
  }
}

ResourceData.defaultProps = {
  isReadOnly: false
};

ResourceData.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  entitlements: PropTypes.array.isRequired,
  project: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
  hiddenProps: PropTypes.array,
  datasetIRI: PropTypes.string,
  isReadOnly: PropTypes.bool,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  projectUsers: PropTypes.array,
  useWorkflow: PropTypes.bool,
  ontologyProjects: PropTypes.array,
  onFoundResource: PropTypes.func,
  taxonomies: PropTypes.array,
  linkedData: PropTypes.array,
  annotate: PropTypes.bool,
  associatedProject: PropTypes.array,
  defaultClasses: PropTypes.array,
  resourceIRI: PropTypes.string.isRequired,
  onDeleteResource: PropTypes.func.isRequired,
  propertyTemplates: PropTypes.array,
  classes: PropTypes.object
};

export default withStyles(styles)(withGS(ResourceData, ["ALL"], null, {}, true));